import { roundHalfUp } from '@/lib/format';
import type { BandPosition } from './bandTypes';

/**
 * 저점매수 보유 한 건에 살아 있는 시세(15초)를 덮어쓴다. (2026-09-16, BACKLOG I-54)
 *
 * 🔴 왜 화면에서 다시 계산하나
 *   상태 응답(currentPrice · unrealizedPercent)은 2분 주기다. 같은 칸의 "전날 대비" 는
 *   15초 시세라 두 숫자가 최대 2분 어긋났다. 감시 대상 표가 이미 같은 방식으로 거리를 다시 잰다
 *   (bandDisplay.targetDistancePercent).
 *
 * 계산은 서버(BandStatusResponse.Position)와 같다.
 *   unrealizedPercent = (현재가 − 평단) / 평단 × 100, 소수 2자리 HALF_UP, 수수료는 빼지 않는다
 *   JS Math.round 는 음수 .5 에서 Java HALF_UP 과 갈리므로 lib/format 의 roundHalfUp 을 쓴다 (CLAUDE.md 6.1)
 *
 * @param livePrice 15초 폴링 시세. 없으면 서버 값을 그대로 둔다 - 없는 값을 만들지 않는다
 */
export function withLivePrice(position: BandPosition, livePrice: number | null): BandPosition {
  if (livePrice === null || position.avgPrice <= 0) {
    return position;
  }
  return {
    ...position,
    currentPrice: livePrice,
    unrealizedPercent: roundHalfUp(((livePrice - position.avgPrice) / position.avgPrice) * 100, 2),
  };
}
